import { Button } from '@/components/ui/buttons';
import { getAddressByNAID } from '@/services/user/adresses.server';
import { ErrorMessage, Field, Form, Formik, useFormikContext } from 'formik';
import { useLocale, useTranslations } from 'next-intl';
import { useState } from 'react';
import { toast } from '@/utils/toast';
import { object, string } from 'yup';

const AddressFormContent = ({
  handleOnClose,
  isLoading,
  t,
  locale,
}) => {
  const { values, setFieldError, setValues, submitForm } = useFormikContext();
  const [isLoadingAddress, setIsLoadingAddress] = useState(false);

  const handleGetAddress = async () => {
    if (values.naid?.length < 8) {
      setFieldError(
        'naid',
        t('The NAID must be at least 8 characters (4 numbers + 4 letters)')
      );
      return;
    }

    setFieldError('naid', null);
    setIsLoadingAddress(true);

    try {
      const data = await getAddressByNAID(values.naid, locale);
      console.log('national addrress ==========>', data);

      if (!+data.totalSearchResults) {
        setFieldError('naid', t('INVALID_NAID_PLEASE_TRY_AGAIN'));
      } else if (data?.Addresses?.length > 0) {
        setValues({
          ...values,
          lat: data.Addresses?.[0]?.Latitude || '',
          long: data.Addresses?.[0]?.Longitude || '',
          street: `${data.Addresses?.[0]?.Address1}, ${data.Addresses?.[0]?.Address2}`,
        });
      }
    } catch (error) {
      setFieldError('naid', error?.message || 'An error occurred');
    } finally {
      setIsLoadingAddress(false);
    }
  };

  return (
    <Form className='px-[29px] pt-[11px] pb-[22px] max-sm:px-2'>
      <div className='mb-[18px]'>
        <label>{t('National Address ID (NAID)')}</label>
        <Field
          type='text'
          name='naid'
          placeholder={t('Enter your NAID')}
          className={`mt-1 w-full rounded-md border border-[#E4E4F9] px-2 py-1.5 outline-none max-lg:text-sm max-lg:placeholder:text-sm lg:px-4`}
        />
        <ErrorMessage
          name='naid'
          component='p'
          className='mt-1 text-xs text-red-500'
        />
        <Button
          type='button'
          onClick={handleGetAddress}
          disabled={isLoadingAddress || isLoading}
          className='border-primary hover:bg-primary mt-[11px] h-[45px] w-full rounded-[5px] border bg-transparent text-[15px] font-bold text-black! duration-200 hover:text-white!'
        >
          {isLoadingAddress && (
            <span className='size-4 animate-spin rounded-full border-t border-r border-white max-lg:size-2' />
          )}
          {t('Get Address')}
        </Button>
      </div>

      <label>{t('Address')}</label>

      <Field
        disabled
        name='street'
        placeholder={t('The address will appear here')}
        className={`mt-1 w-full rounded-md border border-[#E4E4F9] px-2 py-1.5 outline-none max-lg:text-sm max-lg:placeholder:text-sm lg:px-4`}
      />

      <div className='flex items-center justify-between pt-[17px] max-sm:gap-2'>
        <Button
          type='button'
          onClick={handleOnClose}
          className='flex h-[45px] w-[9.439rem] items-center justify-center rounded-[5px] border border-[#BBBBBB] bg-linear-to-b from-[#F7F8FA] to-[#E7E9EC] text-[15px] font-bold text-black! shadow-[inset_0_1px_0_1px_#FFFFFF4D]'
        >
          {t('Cancel')}
        </Button>
        <Button
          type='button'
          onClick={submitForm}
          disabled={isLoadingAddress || isLoading}
          className='bg-primary h-[45px] w-[16.063rem] rounded-[5px] text-[15px] font-bold text-white'
        >
          {isLoading && (
            <span className='size-4 animate-spin rounded-full border-t border-r border-white max-lg:size-2' />
          )}
          {t('Confirm address')}
        </Button>
      </div>
    </Form>
  );
};

const AddEditAddressNationalAddress = ({
  handleOnClose,
  handleSubmit,
  selectedAddress,
  isLoading,
}) => {
  const t = useTranslations('modals');
  const locale = useLocale();

  const lat = selectedAddress?.custom_attributes?.find(
    (e) => e?.attribute_code === 'lat'
  )?.value;
  const lng = selectedAddress?.custom_attributes?.find(
    (e) => e?.attribute_code === 'lng'
  )?.value;

  const street = selectedAddress?.street?.[0] || '';

  const validationSchema = object({
    naid: string().min(
      8,
      t('The NAID must be at least 8 characters (4 numbers + 4 letters)')
    ),
  });

  return (
    <Formik
      initialValues={{
        naid: '',
        lat: lat ?? '',
        long: lng ?? '',
        street: street ?? '',
      }}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        const { lat, long, street } = values;
        if (lat && long && street) {
          handleSubmit({ lat, long, street });
        } else {
          toast.error(
            locale === 'ar'
              ? 'عنوان غير صحيح، حاول  مرة اخرى'
              : 'Invalid NAID, please try again'
          );
        }
      }}
    >
      <AddressFormContent
        handleOnClose={handleOnClose}
        isLoading={isLoading}
        t={t}
        locale={locale}
        handleSubmit={handleSubmit}
      />
    </Formik>
  );
};

export default AddEditAddressNationalAddress;
